const dataApiUrl = () => {
  const dataApi = new URL(process.env.REACT_APP_DATA_API_URL);
  return dataApi.origin;
};

export { dataApiUrl };
